module.exports = __webpack_public_path__ + "img/15.5955a3ff.jpg";